import moment from 'moment-timezone'
export default function ({ store, redirect, app }) {
  // If the user is not authenticated
  if (!store.getters['auth/isAuthenticated']) {
    return redirect('/')
  }
  // check for expired_at
  const userIdentity = store.getters['auth/userIdentity']
  if (userIdentity) {
    const now = moment().tz(app.context.env.TIMEZONE)
    const expiredAt = moment(userIdentity.expired_at)
      .tz(app.context.env.TIMEZONE)
    // console.log('expire in', expiredAt.diff(now, 'second'))
    const isExpired = !expiredAt.isValid() || (expiredAt.diff(now, 'second') < 0)
    if (isExpired) {
      store.dispatch('auth/LOGOUT')
      return redirect('/')
    }
  }
}
